import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../contextos/AuthContext';
import { Button, Icon, Input } from '../../../ui';
import AuthLayout from '../AuthLayout';
import styles from './RecuperarSenha.module.css';

/** Página dedicada de recuperação de senha (rota /recuperar-senha). */
export default function RecuperarSenha() {
  const { esqueciSenha, processando } = useAuth();

  const [email, setEmail] = useState('');
  const [erro, setErro] = useState('');
  const [enviado, setEnviado] = useState(false);

  const submeter = async () => {
    if (processando) return;
    setErro('');
    if (!email.trim()) {
      setErro('Informe o e-mail cadastrado.');
      return;
    }
    await esqueciSenha(email.trim());
    // Resposta sempre neutra: não revelamos se o e-mail existe ou não.
    setEnviado(true);
  };

  if (enviado) {
    return (
      <AuthLayout titulo="Verifique seu e-mail" subtitulo="O próximo passo chega na sua caixa de entrada.">
        <div className={styles.sucesso} role="status">
          <span className={styles.sucessoIcone}>
            <Icon nome="mark_email_read" tamanho={24} cor="var(--success)" />
          </span>
          <p className={styles.sucessoTexto}>
            Se este e-mail estiver cadastrado, enviamos um link para você definir uma nova senha. Verifique sua caixa de
            entrada e também a pasta de spam.
          </p>
          <Link to="/entrar" className={styles.linkBotao}>
            Voltar para o login
          </Link>
        </div>
      </AuthLayout>
    );
  }

  return (
    <AuthLayout
      titulo="Recuperar acesso"
      subtitulo="Informe o e-mail da sua conta e enviaremos um link para redefinir a senha."
    >
      <div className={styles.form}>
        <Input
          label="E-mail cadastrado"
          tipo="email"
          icone="mail"
          valor={email}
          onChange={setEmail}
          placeholder="voce@exemplo.com"
          erro={erro}
          autoFocus
          onEnter={submeter}
        />

        <Button tamanho="lg" icone="forward_to_inbox" carregando={processando} onClick={submeter}>
          Enviar link de recuperação
        </Button>

        <p className={styles.trocaFluxo}>
          Lembrou da senha?{' '}
          <Link to="/entrar" className={styles.link}>
            Entrar
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
